import { createActions } from 'redux-actions';

export const {
  getModelsTypes,
  getModelsTypesSuccess,
  getModelsTypesError,
  getVehicleTypes,
  getVehicleTypesSuccess,
  getVehicleTypesError,
  getAdvertisingsTypes,
  getAdvertisingsTypesSuccess,
  getAdvertisingsTypesError,
  getAppliancesTypes,
  getAppliancesTypesSuccess,
  getAppliancesTypesError,
  getBrandsTypes,
  getBrandsTypesSuccess,
  getBrandsTypesError,
  getCategoriesTypes,
  getCategoriesTypesSuccess,
  getCategoriesTypesError,
  getColorsTypes,
  getColorsTypesSuccess,
  getColorsTypesError,
  getConditionersTypes,
  getConditionersTypesSuccess,
  getConditionersTypesError,
  getDriveTypes,
  getDriveTypesSuccess,
  getDriveTypesError,
  getEngineTypes,
  getEngineTypesSuccess,
  getEngineTypesError,
  getEntertainmentsTypes,
  getEntertainmentsTypesSuccess,
  getEntertainmentsTypesError,
  getFacilitiesTypes,
  getFacilitiesTypesSuccess,
  getFacilitiesTypesError,
  getFunctionsTypes,
  getFunctionsTypesSuccess,
  getFunctionsTypesError,
  getInteriorsTypes,
  getInteriorsTypesSuccess,
  getInteriorsTypesError,
  getSeatMaterialsTypes,
  getSeatMaterialsTypesSuccess,
  getSeatMaterialsTypesError,
  getTachographsTypes,
  getTachographsTypesSuccess,
  getTachographsTypesError,
  getTintsTypes,
  getTintsTypesSuccess,
  getTintsTypesError,
  getTransfersTypes,
  getTransfersTypesSuccess,
  getTransfersTypesError,
  getParkingTypes,
  getParkingTypesSuccess,
  getParkingTypesError,
  getModelsByBrand,
  getModelsByBrandSuccess,
  getModelsByBrandError,
  getModelsByBrandsKeys,
  getModelsByBrandsKeysSuccess,
  getModelsByBrandsKeysError,
  getSteeringArrangementTypes,
  getSteeringArrangementTypesSuccess,
  getSteeringArrangementTypesError,
  getDriveUnitTypes,
  getDriveUnitTypesSuccess,
  getDriveUnitTypesError,
} = createActions(
  'GET_MODELS_TYPES',
  'GET_MODELS_TYPES_SUCCESS',
  'GET_MODELS_TYPES_ERROR',
  'GET_VEHICLE_TYPES',
  'GET_VEHICLE_TYPES_SUCCESS',
  'GET_VEHICLE_TYPES_ERROR',
  'GET_ADVERTISINGS_TYPES',
  'GET_ADVERTISINGS_TYPES_SUCCESS',
  'GET_ADVERTISINGS_TYPES_ERROR',
  'GET_APPLIANCES_TYPES',
  'GET_APPLIANCES_TYPES_SUCCESS',
  'GET_APPLIANCES_TYPES_ERROR',
  'GET_BRANDS_TYPES',
  'GET_BRANDS_TYPES_SUCCESS',
  'GET_BRANDS_TYPES_ERROR',
  'GET_CATEGORIES_TYPES',
  'GET_CATEGORIES_TYPES_SUCCESS',
  'GET_CATEGORIES_TYPES_ERROR',
  'GET_COLORS_TYPES',
  'GET_COLORS_TYPES_SUCCESS',
  'GET_COLORS_TYPES_ERROR',
  'GET_CONDITIONERS_TYPES',
  'GET_CONDITIONERS_TYPES_SUCCESS',
  'GET_CONDITIONERS_TYPES_ERROR',
  'GET_DRIVE_TYPES',
  'GET_DRIVE_TYPES_SUCCESS',
  'GET_DRIVE_TYPES_ERROR',
  'GET_ENGINE_TYPES',
  'GET_ENGINE_TYPES_SUCCESS',
  'GET_ENGINE_TYPES_ERROR',
  'GET_ENTERTAINMENTS_TYPES',
  'GET_ENTERTAINMENTS_TYPES_SUCCESS',
  'GET_ENTERTAINMENTS_TYPES_ERROR',
  'GET_FACILITIES_TYPES',
  'GET_FACILITIES_TYPES_SUCCESS',
  'GET_FACILITIES_TYPES_ERROR',
  'GET_FUNCTIONS_TYPES',
  'GET_FUNCTIONS_TYPES_SUCCESS',
  'GET_FUNCTIONS_TYPES_ERROR',
  'GET_INTERIORS_TYPES',
  'GET_INTERIORS_TYPES_SUCCESS',
  'GET_INTERIORS_TYPES_ERROR',
  'GET_SEAT_MATERIALS_TYPES',
  'GET_SEAT_MATERIALS_TYPES_SUCCESS',
  'GET_SEAT_MATERIALS_TYPES_ERROR',
  'GET_TACHOGRAPHS_TYPES',
  'GET_TACHOGRAPHS_TYPES_SUCCESS',
  'GET_TACHOGRAPHS_TYPES_ERROR',
  'GET_TINTS_TYPES',
  'GET_TINTS_TYPES_SUCCESS',
  'GET_TINTS_TYPES_ERROR',
  'GET_TRANSFERS_TYPES',
  'GET_TRANSFERS_TYPES_SUCCESS',
  'GET_TRANSFERS_TYPES_ERROR',
  'GET_PARKING_TYPES',
  'GET_PARKING_TYPES_SUCCESS',
  'GET_PARKING_TYPES_ERROR',
  'GET_MODELS_BY_BRAND',
  'GET_MODELS_BY_BRAND_SUCCESS',
  'GET_MODELS_BY_BRAND_ERROR',
  'GET_MODELS_BY_BRANDS_KEYS',
  'GET_MODELS_BY_BRANDS_KEYS_SUCCESS',
  'GET_MODELS_BY_BRANDS_KEYS_ERROR',
  'GET_STEERING_ARRANGEMENT_TYPES',
  'GET_STEERING_ARRANGEMENT_TYPES_SUCCESS',
  'GET_STEERING_ARRANGEMENT_TYPES_ERROR',
  'GET_DRIVE_UNIT_TYPES',
  'GET_DRIVE_UNIT_TYPES_SUCCESS',
  'GET_DRIVE_UNIT_TYPES_ERROR'
);
